export const ROUTES = {
  HOME: '/',
  TASK: '/task',
  TASKS: '/tasks',
  SIGN_IN: '/sign-in',
  REQUEST: '/request',
  COMPANY: '/company',
  OVERVIEW: '/overview',
  REQUESTS: '/requests',
  CONTACTS: '/contacts',
  COMPANIES: '/companies',
  NOT_FOUND: '/not-found',
  STATISTICS: '/statistics',
  MEETING_NOTES: '/meeting-notes',
  EDIT_USER_DATA: '/profile-settings',
  FORGOT_PASSWORD: '/forgot-password',
  RESTORE_PASSWORD: '/restore-password',
  GOOGLE_AUTH_CALLBACK: '/auth/callback',
  INVITE_USER: '/invite-user/:invitationSecret',
  CLIENTS_FEEDBACK: '/clients-feedback/:feedbackId',
  CONTACTS_MESSAGES: '/contacts/:contactId/messages',
};

export const reduxRoutes = {
  [ROUTES.HOME]: {
    title: 'Home',
  },
  [ROUTES.STATISTICS]: {
    title: 'Statistics',
  },
  [ROUTES.REQUEST]: {
    title: 'Request',
  },
  [ROUTES.REQUESTS]: {
    title: 'Requests',
  },
  [ROUTES.CONTACTS]: {
    title: 'Contacts',
  },
  [ROUTES.CONTACTS_MESSAGES]: {
    title: 'Contact Messages',
  },
  [ROUTES.OVERVIEW]: {
    title: 'Overview',
  },
  [ROUTES.EDIT_USER_DATA]: {
    title: 'Edit user data',
  },
  [ROUTES.INVITE_USER]: {
    title: 'Invite user',
  },
  [ROUTES.SIGN_IN]: {
    title: 'Sign in',
  },
  [ROUTES.MEETING_NOTES]: {
    title: 'Meeting notes',
  },
  [ROUTES.NOT_FOUND]: {
    title: 'Not found',
  },
  [ROUTES.TASKS]: {
    title: 'Tasks',
  },
  [ROUTES.RESTORE_PASSWORD]: {
    title: 'Restore password',
  },
  [ROUTES.FORGOT_PASSWORD]: {
    title: 'Forgot password',
  },
  [ROUTES.TASK]: {
    title: 'Task',
  },
  [ROUTES.GOOGLE_AUTH_CALLBACK]: {
    title: 'Google Auth Callback',
  },
  [ROUTES.CLIENTS_FEEDBACK]: {
    title: 'Clients Feedback',
  },
  [ROUTES.COMPANIES]: {
    title: 'Companies',
  },
  [ROUTES.COMPANY]: {
    title: 'Company',
  },
};

export const titles = {
  [ROUTES.HOME]: 'Apiko Admin',
  [ROUTES.INVITE_USER]: 'Apiko Admin',
  [ROUTES.TASKS]: 'Tasks | Apiko Admin',
  [ROUTES.SIGN_IN]: 'Sign in | Apiko Admin',
  [ROUTES.OVERVIEW]: 'Overview | Apiko Admin',
  [ROUTES.REQUESTS]: 'Requests | Apiko Admin',
  [ROUTES.CONTACTS]: 'Contacts | Apiko Admin',
  [ROUTES.COMPANIES]: 'Companies | Apiko Admin',
  [ROUTES.NOT_FOUND]: 'Not found | Apiko Admin',
  [ROUTES.STATISTICS]: 'Statistics | Apiko Admin',
  [ROUTES.MEETING_NOTES]: 'Meeting notes | Apiko Admin',
  [ROUTES.EDIT_USER_DATA]: 'Profile settings | Apiko Admin',
  [ROUTES.FORGOT_PASSWORD]: 'Forgot password | Apiko Admin',
  [ROUTES.GOOGLE_AUTH_CALLBACK]: 'Google Auth | Apiko Admin',
  [ROUTES.RESTORE_PASSWORD]: 'Restore password | Apiko Admin',
  [ROUTES.CONTACTS_MESSAGES]: 'Contact Messages | Apiko Admin',
};

export const SUPER_ADMIN_ROUTES = [
  ROUTES.MEETING_NOTES,
];



// WEBPACK FOOTER //
// ./src/routes/constants.js